enum UserRole {
  Administrator = 'Administrator',
  Moderator = 'Moderator'
}

export { UserRole }